import React from 'react';
import { isString } from 'lodash';

export default React.memo(function Excerpt({
  text = '',
  maxLength = 350,
  showEllipses = true
}) {
  if (!text || !isString(text)) {
    return null;
  }

  text = text.trim();

  const isTruncated = text.length > maxLength;

  if (isTruncated) {
    text = text.substring(0, maxLength);
  }

  const paragraphs = text.split(/\r\n|\r|\n/);

  return paragraphs.map((content, index) => {
    content = text.trim().replace(/…|\.\.\./, '');

    if (!content) {
      return null;
    }

    if (showEllipses && isTruncated && index === paragraphs.length - 1) {
      content += '…';
    }

    return <p key={index}>{content}</p>;
  });
});
